import { FC } from 'react'

import type { Text } from '../models'

export const TextComp: FC<Text> = ({ text }) => <>{text}</>
